export default __webpack_public_path__ + "18037e9b6bcc880f66c3b5179b511b4f.png";